import { LESSON_EXECUTION_STATUS, USER_ROLE } from '~/shared/constants';
import type { CallPolicyContext } from '~/shared/permissions/types';

export function canCall(user, permission, ctx: CallPolicyContext = { lesson: null }) {
  const lesson = ctx.lesson;

  switch (permission) {
    case 'call.join':
      return !!lesson;

    case 'call.screen_share':
      return (
        lesson?.videoCallStatus === LESSON_EXECUTION_STATUS.LESSON_STARTED &&
        [USER_ROLE.ADMIN, USER_ROLE.SUPER_TEACHER, USER_ROLE.TEACHER, USER_ROLE.STUDENT].includes(user.role)
      );

    case 'call.transfer_control':
      return (
        lesson?.videoCallStatus === LESSON_EXECUTION_STATUS.LESSON_STARTED &&
        [USER_ROLE.ADMIN, USER_ROLE.SUPER_TEACHER, USER_ROLE.TEACHER].includes(user.role)
      );

    case 'call.toggle_student_camera':
      return (
        lesson?.videoCallStatus === LESSON_EXECUTION_STATUS.LESSON_STARTED &&
        [USER_ROLE.ADMIN, USER_ROLE.SUPER_TEACHER, USER_ROLE.TEACHER].includes(user.role)
      );

    default:
      return false;
  }
}
